import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.css';
import { UIHeading1, UIText1, useDeviceType } from '@cian/ui-kit';

export const ErrorModalContent: React.FC = () => {
  const deviceType = useDeviceType();
  const isPhone = deviceType === 'phone';

  return (
    <div className={clsx(isPhone ? styles['container-mobile'] : styles['container'])}>
      <span className={styles['heading']}>
        <UIHeading1>Что то пошло не так</UIHeading1>
      </span>
      <div className={styles['content']}>
        <UIText1>Попробуйте позже</UIText1>
      </div>
    </div>
  );
};
